/*
 * @Author: edvardchen
 * @Date:   2016-11-15 14:39:12
 * @Last Modified by: qiyuanchen
 * @Last Modified time: 2019-12-26 20:43:50
 */

import _ from 'lodash';
import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
// import { listen } from 'fbjs/lib/EventListener';
import autobind from 'core-decorators/lib/autobind';
import hyphenateStyleName from 'fbjs/lib/hyphenateStyleName';
import shallowEqual from 'fbjs/lib/shallowEqual';

import Image from './ImageInArticle';
import QBLink from '../QBLink';
import Video from './Video';
import VideoDBLink from './VideoDBLink';
import VideoIframe from './VideoIframe';
import BookCard from '../Article_new/BookCard';
import styles from './Content.scss';
import { data2ContentDom } from '../../utility/DOM';
import RumorHeader from '../Article_new/rumor/header';
import RumorFooter from '../Article_new/rumor/footer';

export default class Content extends React.Component {
  static propTypes = {
    share: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
    onPlayVideo: PropTypes.func,
    videoDBLinkText: PropTypes.string,
    onClickVideoDBLink: PropTypes.func,
    onClickImage: PropTypes.func,
    onClickArticleImageBtn: PropTypes.func,
    contentFields: PropTypes.array.isRequired,
  };
  componentDidMount() {
    /* eslint-disable react/no-find-dom-node */
    const el = ReactDom.findDOMNode(this);
    if (el && el.getElementsByTagName) {
      const linkArray = Array.prototype.slice
        .call(el.getElementsByTagName('a'))
        .filter((e) => e.getAttribute('type') === 'anchor');
      linkArray.forEach((linkElem) => {
        if (linkElem) {
          try {
            const beforeElm = linkElem.previousSibling;
            const nextElm = linkElem.nextSibling;
            if (beforeElm && nextElm) {
              beforeElm.appendChild(linkElem);
              nextElm.childNodes.forEach((child) => {
                beforeElm.appendChild(child);
              });
              nextElm.remove();
            }
          } catch (e) {
            console.log('linkElem add error', e);
            // linkElem.remove();
          }
        }
      });
    }
  }
  shouldComponentUpdate(nextProps) {
    const { contentFields, style } = this.props;
    // 简单比较一下长度
    if (nextProps.contentFields.length === contentFields.length) {
      const keys = ['share', 'videoDBLinkText'];
      if (shallowEqual(_.pick(this.props, ...keys), _.pick(nextProps, ...keys))) {
        if (!shallowEqual(nextProps.style, style)) {
          Object.assign(this.props.style, nextProps.style);
          this.renderStyle();
        }
        return false;
      }
    }
    return true;
  }
  renderStyle() {
    const style = _.mapKeys(this.props.style, (value, key) => hyphenateStyleName(key));
    Object.assign(this.el.style, style);
  }

  @autobind
  renderFieldComponent(item, key) {
    const {
      onPlayVideo,
      share,
      videoDBLinkText,
      onClickImage,
      onClickArticleImageBtn,
      onClickVideoDBLink,
    } = this.props;

    const { type, ...itemRest } = item;
    switch (type) {
      case 'image':
        return (
          <Image
            key={key}
            {...itemRest}
            onClickArticleImageBtn={() => onClickArticleImageBtn && onClickArticleImageBtn()}
            onClickImage={({ currentTarget: el }) => onClickImage && onClickImage({ src: item.src, el })}
          />
        );
      case 'video': {
        if (share && videoDBLinkText) {
          return (
            <Video onPlay={onPlayVideo} {...itemRest} hideTitle key={key}>
              <VideoDBLink text={videoDBLinkText} onClick={onClickVideoDBLink} />
            </Video>
          );
        }
        return <Video onPlay={onPlayVideo} {...itemRest} key={key} />;
      }
      case 'text':
        /* eslint-disable react/no-danger */
        return <span key={key} dangerouslySetInnerHTML={{ __html: itemRest.value }} />;
      case 'strong':
        return (
          <p>
            <strong key={key}>{data2ContentDom(itemRest.value)}</strong>
          </p>
        );
      case 'link': {
        const parts = itemRest.value.split('|#|');
        if (parts.length < 2) {
          return null;
        }
        return <QBLink key={key} url={parts[0]} text={parts[1]} />;
      }
      case 'video-iframe':
        return <VideoIframe key={key} {...itemRest} />;
      case 'book':
        return <BookCard {...itemRest} key={key} />;
      case 'anchor':
        if (!itemRest.url || !itemRest.anchorText) {
          return null;
        }
        return <QBLink key={key} url={itemRest.url} text={itemRest.anchorText} type="anchor" />;
      case 'rumor_header':
        return <RumorHeader key={key} {...itemRest} />;
      case 'rumor_footer':
        return <RumorFooter key={key} {...itemRest} />;
      default:
        return null;
    }
  }

  render() {
    const { style, contentFields, className } = this.props;
    const name = `${className} ${styles.content} content G-can-be-select`;
    return (
      <article
        ref={(node) => {
          this.el = node;
        }}
        style={style}
        className={name}
      >
        {contentFields
          .map((item, index) => {
            if (Array.isArray(item)) {
              return (
                <div key={index} className="at-content-div">
                  {item.map(this.renderFieldComponent).filter(Boolean)}
                </div>
              );
            }
            if (item.type === 'text' && item.value) {
              return <p key={index}>{data2ContentDom(item.value)}</p>;
            }
            return this.renderFieldComponent(item, index);
          })
          .filter(Boolean)}
      </article>
    );
  }
}
